<div class="modal">
    <i class="fal fa-times modal__close" (click)="close()"></i>
    <h2 class="mb-0075"> {{isCreate ? 'Create' : 'Update'}} Phone</h2>
    <app-phone-form [formControl]="formControl">
    </app-phone-form>

    <div class="col__" content-outlet="buttons">
        <button class="btn floatRight" type="submit"
        data-test-id="save"
        [appButtonSpinner]="isSaving"
        [disabled]="formControl.invalid || isSaving"
        (click)="onSaveClicked()"
        >Save</button>
    </div>

</div>
